import { GridFilterItem, GridSortItem } from '@mui/x-data-grid-pro';

import { QueryOption } from '../@types';
import { httpClient, HttpMethod } from './http-client';
import { Role, RoleListResponse } from '../@types/role.type';
import { isNotArrayEmpty } from '../utils/array-utils';

export const getRoles = (queryOptions: QueryOption): Promise<RoleListResponse> => {
  const { filterModel, page, pageSize, sortModel } = queryOptions;
  let url = `/roles?limit=${pageSize}&page=${page + 1}`;

  if (sortModel && isNotArrayEmpty(sortModel as GridSortItem[], 0)) {
    url += `&order_by=${sortModel[0]?.field}&order_direction=${sortModel[0]?.sort}`;
  }

  filterModel?.items?.forEach((filter: GridFilterItem) => {
    url += `&${filter?.field}=${filter?.operator},${filter.value}`;
  });

  return httpClient<RoleListResponse>(url, HttpMethod.Get);
};

export const getActiveRoles = (): Promise<Role[]> => {
  return httpClient<Role[]>('/roles/activeroles', HttpMethod.Get);
};

export const getRoleById = (id: number): Promise<Role> => {
  return httpClient<Role>(`/roles/${id}`, HttpMethod.Get);
};

export const createRole = (role: Partial<Role>): Promise<Role> => {
  return httpClient<Role>('/roles', HttpMethod.Post, role);
};

export const updateRole = (id: number, role: Partial<Role>): Promise<Role> => {
  return httpClient<Role>(`/roles/${id}`, HttpMethod.Put, role);
};

export interface PermissionTree {
  id: number;
  name: string;
  checked?: boolean;
  children?: PermissionTree[];
}

// These APIs return a root permission tree node with children
export const getRolePermissionForRoleEdit = (id: number): Promise<PermissionTree> => {
  return httpClient<PermissionTree>(`/roles/${id}/permTree/updateRole`, HttpMethod.Get);
};

export const getRolePermissionForUserEdit = (id: number): Promise<PermissionTree> => {
  return httpClient<PermissionTree>(`/roles/${id}/permTree/updateUser`, HttpMethod.Get);
};

export const createRolePermission = (id: number, addedPermissions: number[]): Promise<void> => {
  return httpClient<void>(`/roles/${id}/permissions`, HttpMethod.Post, addedPermissions);
};

export const updateRolePermission = (id: number, addedPermissions: number[]): Promise<void> => {
  return httpClient<void>(`/roles/${id}/updatePermissions`, HttpMethod.Post, addedPermissions);
};

// The permission tree API returns a root node with children
export const getPermission = (): Promise<PermissionTree> => {
  return httpClient<PermissionTree>('/system/permTree', HttpMethod.Get);
};
